import React from "react";
import { useState, useEffect } from "react";
import DateHelpers from "../Helper/DateHelpers";
import '../Styles/PersonalInfo.scss';
import InputValidation from "../Helper/InputValidation";
import { DayCampPageOptions } from "../Constants/RegistrationPageOptions";
import { getRetreatConfig } from "../Constants/RetreatConfig";

// Update error messages names to describe "empty string"/missing required fields.
function PersonalInfo({ week, personalInformation, setPersonalInformation, selectedPage, setSelectedPage, previousPage, nextPage, camper, campMinAge, campMaxAge}) {

   // Ladies' Retreat and Men's Challenge only admit one gender, so the radio buttons are
   // pointless there — the gender is locked and defaulted instead of asked for.
   const fixedGender = getRetreatConfig(week).fixedGender

   useEffect(() => {
      if (fixedGender && personalInformation.gender !== fixedGender) {
         setPersonalInformation({ ...personalInformation, gender: fixedGender })
      }
   }, [fixedGender])

   const [invalidGenderError, setInvalidGenderError] = useState(false)
   const [invalidFirstNameError, setInvalidFirstNameError] = useState(false)
   const [invalidLastNameError, setInvalidLastNameError] = useState(false)
   const [invalidStreetAddress, setInvalidStreetAddress] = useState(false)
   const [invalidCity, setInvalidCity] = useState(false)
   const [invalidState, setInvalidState] = useState(false)
   const [invalidZip, setInvalidZip] = useState(false)
   const [invalidZipFormat, setInvalidZipFormat] = useState(false)
   const [invalidPhone, setInvalidPhone] = useState(false)
   const [invalidPhoneFormat, setInvalidPhoneFormat] = useState(false)
   const [invalidBirthDate, setInvalidBirthDate] = useState(false)
   const [invalidBirthDateFormat, setInvalidBirthDateFormat] = useState(false)
   const [invalidBirthDateAge, setInvalidBirthDateAge] = useState(false)
   const [invalidECName, setInvalidECName] = useState(false)
   const [invalidECRelationship, setInvalidECRelationship] = useState(false)
   const [invalidECPhone, setInvalidECPhone] = useState(false)
   const [invalidECPhoneFormat, setInvalidECPhoneFormat] = useState(false)

   function CalculateMinimumDate() {
      let minimumDate = DateHelpers.subtractFromDate(new Date(), 100)
      let formattedDate = DateHelpers.getFormattedDate(minimumDate)
      return formattedDate;
   }

   function ValidatePersonalInformation() {
      let isError = false;
      // Gender exists
      if (personalInformation.gender === "") {
         setInvalidGenderError(true)
         isError = true;
      }
      // // First name exists
      if (personalInformation.firstName === "") {
         setInvalidFirstNameError(true)
         isError = true
      }
      // Last name exists
      if (personalInformation.lastName === "") {
         setInvalidLastNameError(true)
         isError = true
      }
      // Street address exists
      if (personalInformation.strAddress === "") {
         setInvalidStreetAddress(true)
         isError = true
      }
      // // City exists
      if (personalInformation.city === "") {
         setInvalidCity(true)
         isError = true
      }
      // // State exists
      if (personalInformation.state === "") {
         setInvalidState(true)
         isError = true
      }
      // // Zip exists and is in correct format
      if (personalInformation.zip === "") {
         setInvalidZip(true)
         isError = true
      }
      if (personalInformation.zip != "") {
         const condition = /^(?!00000)\d{5}(?:[-\s](?!0000)\d{4})?$/
         if (condition.test(personalInformation.zip) === false) {
            setInvalidZipFormat(true)
            isError = true
         }
      }
      // // Phone exists
      if (personalInformation.phone === "") {
         setInvalidPhone(true)
         isError = true
      }
      // // Check for valid phone number formats
      if (personalInformation.phone != "") {
         const condition = /^\d{3}[ -]?\d{3}[ -]?\d{4}$/
         if (condition.test(personalInformation.phone) === false) {
            setInvalidPhoneFormat(true)
            isError = true
         }
      }
      // // DOB exists
      if (personalInformation.birthDate === "") {
         setInvalidBirthDate(true)
         isError = true
      }
      if (personalInformation.birthDate != "") {
         var birthDate = new Date(personalInformation.birthDate)
         var today = new Date();
         if (birthDate.getUTCFullYear() <= (today.getFullYear() - 100)) {
            setInvalidBirthDateFormat(true)
            isError = true
         }
         console.log("Birth Date", personalInformation.birthDate)
         const condition = /\d{1,2}\/\d{1,2}\/\d{2,4}/
         if (condition.test(personalInformation.birthDate === false)) {
            setInvalidBirthDateFormat(true)
            isError = true
         }
         var years = DateHelpers.determineDifferenceFromCurrentDate(personalInformation.birthDate)
         console.log("difference in years", years)
         if (years < campMinAge || years > campMaxAge ) {
            setInvalidBirthDateAge(true)
            isError = true
         }
      }
      // EC Name exists
      if (personalInformation.ecName === "") {
         setInvalidECName(true)
         isError = true
      }
      // // EC Relationship exists
      if (personalInformation.ecRelationship === "") {
         setInvalidECRelationship(true)
         isError = true
      }
      // // EC Phone exists
      if (personalInformation.ecPhone === "") {
         setInvalidECPhone(true)
         isError = true
      }
      if (personalInformation.ecPhone != "") {
         const condition = /^\d{3}[ -]?\d{3}[ -]?\d{4}$/
         if (condition.test(personalInformation.ecPhone) === false) {
            setInvalidECPhoneFormat(true)
            isError = true
         }
      }
      // Move on if fully verified
      if (isError === false) {
         console.log("We are here!!")
         setSelectedPage(nextPage)
      }

   }

   return (
         <div className='personalInfoContent'>
            <form>
               <h2 id='personalInfoTitle'>Personal Info</h2>
               {!fixedGender &&
                  <div className="camperGender">
                     {invalidGenderError === true &&
                        <div className="genderError">
                           * Gender is required
                        </div>
                     }
                     {/* Gender Radio Buttons */}

                     <div className='gender'>
                        <div className="MaleLabel">
                           <label id="male">Male</label>
                        </div>
                        <div className="Male">
                           <input
                              type="radio"
                              value="M"
                              name="fav_language"
                              checked={personalInformation.gender === "M"}
                              onChange={(e) => {
                                 setPersonalInformation({ ...personalInformation, gender: (e.target.value) })
                                 setInvalidGenderError(false)
                              }}
                           />
                        </div>
                        <div className='FemaleLabel'>
                           <label className="female">Female</label>
                        </div>

                        <div className="Female">
                           <input
                              type="radio"
                              value="F"
                              name="fav_language"
                              checked={personalInformation.gender === "F"}
                              onChange={(e) => {
                                 setPersonalInformation({ ...personalInformation, gender: (e.target.value) })
                                 setInvalidGenderError(false)
                              }}
                           />
                        </div>
                     </div>
                  </div>
               }

               <div className='camperName'>
                  <div className="firstName">
                     {invalidFirstNameError === true &&
                        <div className="firstNameError">
                           * First name is required
                        </div>
                     }
                     <label>First Name:* </label>
                     <input
                        type="text"
                        required
                        value={personalInformation.firstName}
                        onChange={(e) => {
                           setPersonalInformation({ ...personalInformation, firstName: (e.target.value) });
                           setInvalidFirstNameError(false)
                        }}
                     />
                  </div>

                  <div className="lastName">
                     {invalidLastNameError === true &&
                        <div className="lastNameError">
                           * Last name is required
                        </div>
                     }
                     <label>Last Name:* </label>
                     <input
                        type="text"
                        required
                        value={personalInformation.lastName}
                        onChange={(e) => {
                           setPersonalInformation({ ...personalInformation, lastName: (e.target.value) });
                           setInvalidLastNameError(false)
                        }}
                     />
                  </div>
               </div>

               {/* <h4>Camper Address</h4> */}
               <div className='streetCity'>
                  <div className="addressInput">
                     {invalidStreetAddress === true &&
                        <div className="streetAddressError">
                           * Address is required
                        </div>
                     }
                     <label>Street Address:* </label>
                     <input
                        type="text"
                        required
                        value={personalInformation.strAddress}
                        onChange={(e) => {
                           setPersonalInformation({ ...personalInformation, strAddress: (e.target.value) })
                           setInvalidStreetAddress(false)
                        }}
                     />
                  </div>
                  <div className="addressInput">
                     {invalidCity === true &&
                        <div className="cityError">
                           * City is required
                        </div>
                     }
                     <label>City:* </label>
                     <input
                        type="text"
                        required
                        value={personalInformation.city}
                        onChange={(e) => {
                           setPersonalInformation({ ...personalInformation, city: (e.target.value) })
                           setInvalidCity(false)
                        }}
                     />
                  </div>
               </div>
               <div className="stateZip">
                  <div className="stateInput">
                     {invalidState === true &&
                        <div className="stateError">
                           * State is required
                        </div>
                     }
                     <label for="state">State: </label>
                     <select
                        value={personalInformation.state}
                        defaultValue={personalInformation.state}
                        onChange={event => {
                           setPersonalInformation({ ...personalInformation, state: (event.target.value) })
                           setInvalidState(false)
                        }}
                        id="state"
                        name="state">
                        <option value="---">---</option>
                        <option value="Alabama">Alabama</option>
                        <option value="Alaska">Alaska</option>
                        <option value="Arizona">Arizona</option>
                        <option value="Arkansas">Arkansas</option>
                        <option value="California">California</option>
                        <option value="Colorado">Colorado</option>
                        <option value="Connecticut">Connecticut</option>
                        <option value="Delaware">Delaware</option>
                        <option value="District of Columbia">District of Columbia</option>
                        <option value="Florida">Florida</option>
                        <option value="Georgia">Georgia</option>
                        <option value="Guam">Guam</option>
                        <option value="Hawaii">Hawaii</option>
                        <option value="Idaho">Idaho</option>
                        <option value="Illinois">Illinois</option>
                        <option value="Indiana">Indiana</option>
                        <option value="Iowa">Iowa</option>
                        <option value="Kansas">Kansas</option>
                        <option value="Kentucky">Kentucky</option>
                        <option value="Louisiana">Louisiana</option>
                        <option value="Maine">Maine</option>
                        <option value="Maryland">Maryland</option>
                        <option value="Massachusetts">Massachusetts</option>
                        <option value="Michigan">Michigan</option>
                        <option value="Minnesota">Minnesota</option>
                        <option value="Mississippi">Mississippi</option>
                        <option value="Missouri">Missouri</option>
                        <option value="Montana">Montana</option>
                        <option value="Nebraska">Nebraska</option>
                        <option value="Nevada">Nevada</option>
                        <option value="New Hampshire">New Hampshire</option>
                        <option value="New Jersey">New Jersey</option>
                        <option value="New Mexico">New Mexico</option>
                        <option value="New York">New York</option>
                        <option value="North Carolina">North Carolina</option>
                        <option value="North Dakota">North Dakota</option>
                        <option value="Northern Marianas Islands">Northern Marianas Islands</option>
                        <option value="Ohio">Ohio</option><option value="Oklahoma">Oklahoma</option>
                        <option value="Oregon">Oregon</option>
                        <option value="Pennsylvania">Pennsylvania</option>
                        <option value="Puerto Rico">Puerto Rico</option>
                        <option value="Rhode Island">Rhode Island</option>
                        <option value="South Carolina">South Carolina</option>
                        <option value="South Dakota">South Dakota</option>
                        <option value="Tennessee">Tennessee</option>
                        <option value="Texas">Texas</option>
                        <option value="Utah">Utah</option>
                        <option value="Vermont">Vermont</option>
                        <option value="Virginia">Virginia</option>
                        <option value="Virgin Islands">Virgin Islands</option>
                        <option value="Washington">Washington</option>
                        <option value="West Virginia">West Virginia</option>
                        <option value="Wisconsin">Wisconsin</option>
                        <option value="Wyoming">Wyoming</option>
                     </select>
                  </div>
                  <div className="zipInput">
                     {invalidZip === true &&
                        <div className="zipError">
                           * Zip code is required
                        </div>
                     }
                     {invalidZipFormat === true &&
                        <div className="zipFormatError">
                           * Zip code must be formatted as such: 12345, 12345 6789, or 12345-6789
                        </div>
                     }
                     <label>Zip:* </label>
                     <input
                        type="text"
                        required
                        maxLength={10}
                        value={personalInformation.zip}
                        onChange={(e) => {
                           setPersonalInformation({ ...personalInformation, zip: InputValidation.ValidateInputForPhoneAndZipCode(e.target.value) })
                           setInvalidZip(false)
                           setInvalidZipFormat(false)
                        }} />
                  </div>
               </div>
               {/* <h4>Camper Contact</h4> */}
               <div className='camperContact'>
                  <div className="contactInput">
                     {invalidPhone === true &&
                        <div className="phoneError">
                           * Phone number is required
                        </div>
                     }
                     {invalidPhoneFormat === true &&
                        <div className="phoneFormatError">
                           * Phone number must be formatted as such: 1234567890, 123 456 7890, or 123-456-7890
                        </div>
                     }

                     {/* Change type to "tel" */}
                     <label>Cell Phone #:* </label>
                     <input
                        type="text"
                        required
                        maxLength={12}
                        value={personalInformation.phone}
                        onChange={(e) => {
                           setPersonalInformation({ ...personalInformation, phone: InputValidation.ValidateInputForPhoneAndZipCode(e.target.value) })
                           setInvalidPhone(false)
                           setInvalidPhoneFormat(false)
                        }} />
                  </div>
                  <div className="dateOfBirthInput">
                     {invalidBirthDate === true &&
                        <div className="birthDateError">
                           * Birth date is required
                        </div>
                     }
                     {invalidBirthDateFormat === true &&
                        <div className="birthDateFormatError">
                           * Campers over the age of 99 are too old to register.
                        </div>
                     }
                     {invalidBirthDateAge === true &&
                        <div className="birthDateAgeError">
                           * Campers must be between the ages of 6 and 12 to register.
                        </div>
                     }
                     <label>Birthdate :*</label>
                     <input
                        type="date"
                        required
                        min={CalculateMinimumDate()}
                        value={personalInformation.birthDate}
                        onChange={(e) => {
                           setPersonalInformation({ ...personalInformation, birthDate: (e.target.value) })
                           setInvalidBirthDate(false)
                           setInvalidBirthDateAge(false)
                           setInvalidBirthDateFormat(false)
                        }} />
                  </div>
               </div>
               <hr></hr>
               <h4>Emergency Contact Info</h4>
               <div className='camperEmergencyContact'>

                  <div className="ecInput">
                     {invalidECName === true &&
                        <div className="ecNameError">
                           * Contact name is required
                        </div>
                     }
                     <label>Name (First Last): * </label>
                     <input
                        type="text"
                        required
                        value={personalInformation.ecName}
                        onChange={(e) => {
                           setPersonalInformation({ ...personalInformation, ecName: (e.target.value) })
                           setInvalidECName(false)
                        }} />
                  </div>

                  <div className="ecInput">
                     {invalidECRelationship === true &&
                        <div className="ecRelationshipError">
                           * Contact relationship is required
                        </div>
                     }
                     <label>Relationship:* </label>
                     <input
                        type="text"
                        required
                        value={personalInformation.ecRelationship}
                        onChange={(e) => {
                           setPersonalInformation({ ...personalInformation, ecRelationship: (e.target.value) })
                           setInvalidECRelationship(false)
                        }} />
                  </div>

                  <div className="ecInput">
                     {invalidECPhone === true &&
                        <div className="ecPhoneError">
                           * Contact phone number is required
                        </div>
                     }
                     {invalidECPhoneFormat === true &&
                        <div className="ecPhoneFormatError">
                           * Phone number must be formatted as such: 1234567890, 123 456 7890, or 123-456-7890
                        </div>
                     }
                     <label>Phone Number:* </label>
                     <input
                        type="tel"
                        id="phone"
                        name="phone"
                        pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}"
                        maxLength={12}
                        required
                        value={personalInformation.ecPhone}
                        onChange={(e) => {
                           setPersonalInformation({ ...personalInformation, ecPhone: InputValidation.ValidateInputForPhoneAndZipCode(e.target.value) })
                           setInvalidECPhone(false)
                           setInvalidECPhoneFormat(false)
                        }}
                     />
                  </div>
               </div>

               <div className="disclaimerPI">
                  <>* Fields are required</>
               </div>
            </form>
            {(
               invalidFirstNameError === true  || invalidLastNameError === true ||
               invalidCity === true            || invalidState === true         ||
               invalidZip === true             || invalidZipFormat === true     ||
               invalidPhone === true           || invalidPhoneFormat === true   ||
               invalidBirthDate === true       || invalidECName === true        ||
               invalidECRelationship === true  || invalidECPhone === true       ||
               invalidBirthDateAge === true    || invalidECPhoneFormat === true ||
               invalidBirthDateFormat === true) &&
               <div className="personalInfoErrorMessage">
                  Please correct the above error(s):
               </div>
            }
            <div className="personalInfoButtonsContainer">
               <div className="personalInfoButtons">
                  <div className="personalInfoPreviousButton">
                     <button className='prevButton' onClick={() => setSelectedPage(previousPage)}>
                        Previous
                     </button>
                  </div>
                  <div className="personalInfoNextButton">
                     <div style={{ color: 'green', margin: '15px, 0', fontFamily: 'Sen' }}></div>
                     <button className="nextButton" onClick={() => ValidatePersonalInformation()}>
                        Next
                     </button>
                  </div>
               </div>
            </div>
         </div>

   )
}
export default PersonalInfo;